import { apiBase } from "./base";

const apiCostSummary = {
	client: apiBase.get_client(),
	url: "/smetdocs/cost_summary/",

	getViewerData({ costSummaryId }) {
		return this.client.get(this.url + costSummaryId + "/", apiBase.get_headers());
	},

	delete({ costSummaryId }) {
		return this.client.delete(this.url + costSummaryId + "/", apiBase.get_headers());
	},

	getXmlCostSummary({ costSummaryId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "text/xml";
		return this.client.get(this.url + "xml/input/" + costSummaryId + "/", headers);
	},

	getPrintXlsxCostSummary({ costSummaryId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "print/xlsx/" + costSummaryId + "/", headers);
	},
};

export default apiCostSummary;
